import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

type Props = {
  isOpen: boolean;
};
export const Container = styled(Column)<Props>`
  position: fixed;
  width: 280px;
  right: 6.94%;
  bottom: 2.5%;
  background-color: ${({ theme }): string => theme.colors.white};
  box-shadow: 0px 10px 40px ${({ theme }): string => theme.colors.boxShadowDarker};
  border-radius: 4px;
  padding: ${({ isOpen }) => (isOpen ? 20 : 10)}px;
  z-index: 3;

  @media (max-width: 1024px) {
    width: ${({ isOpen }) => (!isOpen ? '200px' : '280px')};
  }

  @media (max-width: 1280px), (max-height: 800px) {
    ${({ isOpen }) => (isOpen ? 'max-height: 235px; overflow-y: auto;' : 'overflow-y: hidden;')}
  }
`;
